import { useUpdateTodayGroupByMutation } from 'shared/hooks/queries/use-update-today-group-by-mutation';
export const useUpdateTodayGroupBy = () => {
  const { mutate } = useUpdateTodayGroupByMutation();

  return mutate;
};
